export var DataErrorCodes;
(function (DataErrorCodes) {
    DataErrorCodes["ImportBadRequest"] = "data.import.badRequest";
    DataErrorCodes["ImportDiscoveryIDNotFound"] = "data.import.discoveryIDNotFound";
    DataErrorCodes["ImportDuplicateHeaders"] = "data.import.DuplicateHeaders";
    DataErrorCodes["ImportStreamIDNotFound"] = "data.import.streamIDNotFound";
    DataErrorCodes["ImportRowValidationError"] = "data.import.rowValidationError";
    DataErrorCodes["ImportColumnValidationError"] = "data.import.columnValidationError";
    DataErrorCodes["ImportThirdPartyConnectionTimedout"] = "data.import.thirdPartyConnectionTimedOut";
    DataErrorCodes["ImportUnsupportedEncoding"] = "data.import.UnsupportedEncoding";
    DataErrorCodes["ImportInvalidConfiguration"] = "data.import.InvalidConfiguration";
    DataErrorCodes["ImportFieldSizeExceeded"] = "data.import.FieldSizeExceeded";
    // Import Auth
    DataErrorCodes["ImportOAuthInvalidNonce"] = "data.import.oauth.InvalidNonce";
    DataErrorCodes["ImportOAuthTokenInvalid"] = "data.import.oauth.TokenInvalid";
    DataErrorCodes["ImportOAuthMissingRefreshToken"] = "data.import.oauth.MissingRefreshToken";
    DataErrorCodes["ImportHmacVerificationFailed"] = "data.import.oauth.HmacVerificationFailed";
    // ICM
    DataErrorCodes["ImportIcmApiKeyInvalid"] = "data.import.icm.ApiKeyInvalid";
    DataErrorCodes["IcmHostNotFound"] = "data.import.icm.HostNotFound";
    DataErrorCodes["IcmHostNotAvailable"] = "data.import.icm.HostNotAvailable";
    DataErrorCodes["IcmAccessDenied"] = "data.import.icm.AccessDenied";
    DataErrorCodes["IcmBadRequest"] = "data.import.icm.BadRequest";
    DataErrorCodes["IcmClientError"] = "data.import.icm.ClientError";
    DataErrorCodes["IcmServerError"] = "data.import.icm.ServerError";
    DataErrorCodes["IcmEmptyTableError"] = "data.import.icm.EmptyTableError";
    DataErrorCodes["IcmConnectionResetError"] = "data.import.icm.ConnectionResetError";
    DataErrorCodes["IcmBadDomainError"] = "data.import.icm.BadDomainError";
    // SalesForce
    DataErrorCodes["ImportSalesForceAuthInvalid"] = "data.import.salesForce.AuthInvalid";
    DataErrorCodes["ImportSalesForceApiDisabled"] = "data.import.salesForce.ApiDisabled";
    DataErrorCodes["ImportSalesForceBulkApiDisabled"] = "data.import.salesforce.BulkApiDisabled";
    DataErrorCodes["ImportSalesForceInvalidField"] = "data.import.salesforce.InvalidField";
    DataErrorCodes["ImportSalesForceInvalidFilter"] = "data.import.salesforce.InvalidFilter";
    DataErrorCodes["ImportSalesForceApiError"] = "data.import.salesforce.SalesforceApiError";
    // MsSql
    DataErrorCodes["ImportMsSqlAuthInvalid"] = "data.import.msSql.AuthInvalid";
    DataErrorCodes["ImportMsSqlQueryTimeout"] = "data.import.msSql.QueryTimeout";
    // Dynamics
    DataErrorCodes["ImportDynamicsAuthInvalid"] = "data.import.dynamics.AuthInvalid";
    DataErrorCodes["ImportDynamicsApiError"] = "data.import.dynamics.DynamicsApiError";
    DataErrorCodes["ImportDynamicsInvalidUrl"] = "data.import.dynamics.InvalidUrl";
    // ODBC
    DataErrorCodes["ImportOdbcAuthenticationFailed"] = "data.import.odbc.AuthenticationFailed";
    DataErrorCodes["ImportOdbcDatabaseDoesNotExist"] = "data.import.odbc.DatabaseDoesNotExist";
    DataErrorCodes["ImportOdbcConnectionTimeout"] = "data.import.odbc.ConnectionTimeout";
    DataErrorCodes["ImportOdbcHostNotFound"] = "data.import.odbc.HostNotFound";
    DataErrorCodes["ImportOdbcTableNotFound"] = "data.import.odbc.TableNotFound";
    DataErrorCodes["ImportOdbcConnectionFailed"] = "data.import.odbc.ConnectionFailed";
    DataErrorCodes["ImportOdbcEmptyData"] = "data.import.odbc.EmptyData";
    // Google AdWords
    DataErrorCodes["AdWordsUserIsNotManager"] = "data.import.adwords.UserIsNotManager";
    // GSheets
    DataErrorCodes["GoogleApiClientError"] = "data.import.gsheets.GoogleApiClientError";
    // S3Csv
    DataErrorCodes["ImportEncodingError"] = "data.import.encoding";
    DataErrorCodes["ImportEmptyFileError"] = "data.import.EmptyFile";
    // Preprocess Error
    DataErrorCodes["ImportPreprocessError"] = "data.import.PreprocessError";
    // Excel
    DataErrorCodes["ImportExcelOriginIDNotFound"] = "data.import.excel.OriginNotFound";
    DataErrorCodes["ImportExcelInvalidSpec"] = "data.import.excel.InvalidSpecification";
    DataErrorCodes["ImportExcelInvalidFile"] = "data.import.excel.invalidFile";
    DataErrorCodes["ImportExcelNotAZipFile"] = "data.import.excel.notAZipFile";
    DataErrorCodes["ImportExcelUnsupportedFormat"] = "data.import.excel.UnsupportedFormat";
    DataErrorCodes["ImportExcelWorksheetNotFound"] = "data.import.excel.WorksheetNotFound";
    // Amazon S3
    DataErrorCodes["ImportAmazonS3ListObjectsFailed"] = "data.import.amazonS3.ListObjectsFailed";
    // AgentSync
    DataErrorCodes["AgentSyncApiCallError"] = "data.import.agentSync.AgentSyncApiCallError";
    DataErrorCodes["AgentSyncInvalidKeySecret"] = "data.import.agentSync.InvalidKeySecret";
    // Workday
    DataErrorCodes["WorkdayApiError"] = "data.import.workday.WorkdayApiError";
    DataErrorCodes["WorkdayInvalidDomainError"] = "data.import.workday.InvalidDomain";
    DataErrorCodes["WorkdayInvalidUsernameOrPassword"] = "data.import.workday.InvalidUsernameOrPassword";
    DataErrorCodes["WorkdayConnectionFailed"] = "data.import.workday.ConnectionFailed";
    // Workday RaaS, credentials/api/connection error codes shared with Workday
    DataErrorCodes["WorkdayRaaSInvalidReportURL"] = "data.import.workdayRaaS.WorkdayRaaSInvalidReportURL";
    // Sftp
    DataErrorCodes["SftpListDirectoryFailed"] = "data.import.sftp.ListDirectoryFailed";
    DataErrorCodes["SftpDecryptionKeyInvalid"] = "data.import.sftp.DecryptionKeyInvalid";
    DataErrorCodes["SftpDecryptionFailed"] = "data.import.sftp.DecryptionFailed";
    DataErrorCodes["SftpDecryptionMaxFilesizeError"] = "data.import.sftp.MaxFilesizeError";
    DataErrorCodes["SftpFileNotFoundError"] = "data.import.sftp.FileNotFoundError";
    DataErrorCodes["SftpServerError"] = "data.import.sftp.ServerError";
    DataErrorCodes["SftpAuthenticationError"] = "data.import.sftp.AuthenticationError";
    // Tableau
    DataErrorCodes["TableauSiteNotFound"] = "data.import.tableau.SiteNotFound";
    // TQP
    DataErrorCodes["TqpApiKeyInvalid"] = "data.import.tqp.ApiKeyInvalid";
    DataErrorCodes["TqpHostNotFound"] = "data.import.tqp.HostNotFound";
    DataErrorCodes["TqpClientError"] = "data.import.tqp.ClientError";
    DataErrorCodes["TqpHostNotAvailable"] = "data.import.tqp.HostNotAvailable";
    DataErrorCodes["TqpCanceledByUser"] = "data.import.tqp.CanceledByUser";
    DataErrorCodes["TqpGenericError"] = "data.import.tqp.GenericError";
    // REST
    DataErrorCodes["RestInvalidConfig"] = "data.import.rest.InvalidConfig";
    DataErrorCodes["RestClientError"] = "data.import.rest.ClientError";
    DataErrorCodes["RestInvalidData"] = "data.import.rest.InvalidData";
    // Gong
    DataErrorCodes["GongApiError"] = "data.import.gong.GongApiError";
    // MySql
    DataErrorCodes["MySqlClientError"] = "data.import.mySql.ClientError";
    DataErrorCodes["MySqlServerError"] = "data.import.mySql.ServerError";
    // Snowflake
    DataErrorCodes["SnowflakeClientError"] = "data.import.snowflake.SnowflakeClientError";
    DataErrorCodes["SnowflakeServerError"] = "data.import.snowflake.SnowflakeServerError";
    // Fwf
    DataErrorCodes["FwfInvalidEncodingType"] = "data.import.fwf.FwfInvalidEncodingType";
    // NetSuite
    DataErrorCodes["NetSuiteInvalidKey"] = "data.import.netSuite.NetSuiteInvalidKey";
    DataErrorCodes["NetSuiteInvalidAccountID"] = "data.import.netSuite.NetSuiteInvalidAccountID";
    // OneDrive
    DataErrorCodes["OneDriveTokenError"] = "data.import.oneDrive.OneDriveTokenError";
    DataErrorCodes["OneDriveFileNotFoundError"] = "data.import.oneDrive.OneDriveFileNotFoundError";
    DataErrorCodes["OneDriveFileSizeExceededError"] = "data.import.oneDrive.OneDriveFileSizeExceededError";
    DataErrorCodes["OneDriveApiError"] = "data.import.oneDrive.OneDriveApiError";
    // Hubspot
    DataErrorCodes["HubspotApiError"] = "data.import.hubspot.HubspotApiError";
    DataErrorCodes["HubspotAuthInvalid"] = "data.import.hubspot.AuthInvalid";
    DataErrorCodes["ImportExpiredError"] = "data.import.expired";
    // Catch-all
    DataErrorCodes["ImportUnexpectedError"] = "data.import.unexpected";
})(DataErrorCodes || (DataErrorCodes = {}));
// Map of error code used in tap/target to DataErrorCode
export const SingerErrorCodeToDataErrorCode = new Map([
    ['EmptyFile', DataErrorCodes.ImportEmptyFileError],
    ['PreprocessError', DataErrorCodes.ImportPreprocessError],
    ['UnsupportedEncoding', DataErrorCodes.ImportUnsupportedEncoding],
    ['FieldSizeExceeded', DataErrorCodes.ImportFieldSizeExceeded],
    ['InvalidConfiguration', DataErrorCodes.ImportInvalidConfiguration],
    ['sftp.DecryptionKeyInvalid', DataErrorCodes.SftpDecryptionKeyInvalid],
    ['sftp.DecryptionFailed', DataErrorCodes.SftpDecryptionFailed],
    ['sftp.MaxFilesizeError', DataErrorCodes.SftpDecryptionMaxFilesizeError],
    ['sftp.FileNotFoundError', DataErrorCodes.SftpFileNotFoundError],
    ['sftp.ServerError', DataErrorCodes.SftpServerError],
    ['sftp.AuthenticationError', DataErrorCodes.SftpAuthenticationError],
    ['excel.WorksheetNotFound', DataErrorCodes.ImportExcelWorksheetNotFound],
    ['excel.InvalidSpecification', DataErrorCodes.ImportExcelInvalidSpec],
    ['excel.UnsupportedFormat', DataErrorCodes.ImportExcelUnsupportedFormat],
    ['excel.invalidFile', DataErrorCodes.ImportExcelInvalidFile],
    ['excel.notAZipFile', DataErrorCodes.ImportExcelNotAZipFile],
    ['fwf.FwfInvalidEncodingType', DataErrorCodes.FwfInvalidEncodingType],
    ['oneDrive.OneDriveTokenError', DataErrorCodes.OneDriveTokenError],
    ['oneDrive.OneDriveFileNotFoundError', DataErrorCodes.OneDriveFileNotFoundError],
    ['oneDrive.OneDriveFileSizeExceededError', DataErrorCodes.OneDriveFileSizeExceededError],
    ['oneDrive.OneDriveApiError', DataErrorCodes.OneDriveApiError],
    ['odbc.AuthenticationFailed', DataErrorCodes.ImportOdbcAuthenticationFailed],
    ['odbc.DatabaseDoesNotExist', DataErrorCodes.ImportOdbcDatabaseDoesNotExist],
    ['odbc.ConnectionTimeout', DataErrorCodes.ImportOdbcConnectionTimeout],
    ['odbc.ConnectionFailed', DataErrorCodes.ImportOdbcConnectionFailed],
    ['odbc.HostNotFound', DataErrorCodes.ImportOdbcHostNotFound],
    ['odbc.TableNotFound', DataErrorCodes.ImportOdbcTableNotFound],
    ['odbc.EmptyData', DataErrorCodes.ImportOdbcEmptyData],
    ['msSql.QueryTimeout', DataErrorCodes.ImportMsSqlQueryTimeout],
    ['snowflake.SnowflakeClientError', DataErrorCodes.SnowflakeClientError],
    ['snowflake.SnowflakeServerError', DataErrorCodes.SnowflakeServerError],
    ['mySql.ClientError', DataErrorCodes.MySqlClientError],
    ['mySql.ServerError', DataErrorCodes.MySqlServerError],
    ['salesforce.BulkApiDisabled', DataErrorCodes.ImportSalesForceBulkApiDisabled],
    ['salesforce.InvalidField', DataErrorCodes.ImportSalesForceInvalidField],
    ['salesforce.InvalidFilter', DataErrorCodes.ImportSalesForceInvalidFilter],
    ['salesforce.SalesforceApiError', DataErrorCodes.ImportSalesForceApiError],
    ['rest.InvalidConfig', DataErrorCodes.RestInvalidConfig],
    ['rest.InvalidData', DataErrorCodes.RestInvalidData],
    ['rest.ClientError', DataErrorCodes.RestClientError],
    ['tqp.ApiKeyInvalid', DataErrorCodes.TqpApiKeyInvalid],
    ['tqp.HostNotFound', DataErrorCodes.TqpHostNotFound],
    ['tqp.CanceledByUser', DataErrorCodes.TqpCanceledByUser],
    ['tqp.GenericError', DataErrorCodes.TqpGenericError],
    ['tqp.ClientError', DataErrorCodes.TqpClientError],
    ['icm.BadRequest', DataErrorCodes.IcmBadRequest],
    ['icm.ClientError', DataErrorCodes.IcmClientError],
    ['icm.ServerError', DataErrorCodes.IcmServerError],
    ['workdayRaaS.WorkdayRaaSInvalidReportURL', DataErrorCodes.WorkdayRaaSInvalidReportURL],
    ['workday.InvalidUsernameOrPassword', DataErrorCodes.WorkdayInvalidUsernameOrPassword],
    ['workday.InvalidDomain', DataErrorCodes.WorkdayInvalidDomainError],
    ['workday.ConnectionFailed', DataErrorCodes.WorkdayConnectionFailed],
    ['workday.WorkdayApiError', DataErrorCodes.WorkdayApiError],
    ['hubspot.HubspotApiError', DataErrorCodes.HubspotApiError],
    ['hubspot.AuthInvalid', DataErrorCodes.HubspotAuthInvalid],
    ['gsheets.GoogleApiClientError', DataErrorCodes.GoogleApiClientError],
    ['dynamics.DynamicsApiError', DataErrorCodes.ImportDynamicsApiError],
    ['dynamics.InvalidUrl', DataErrorCodes.ImportDynamicsInvalidUrl],
    ['agentSync.AgentSyncApiCallError', DataErrorCodes.AgentSyncApiCallError],
    ['agentSync.InvalidKeySecret', DataErrorCodes.AgentSyncInvalidKeySecret],
    ['gong.GongApiError', DataErrorCodes.GongApiError],
    ['netSuite.NetSuiteInvalidAccountID', DataErrorCodes.NetSuiteInvalidAccountID],
    ['netSuite.NetSuiteInvalidKey', DataErrorCodes.NetSuiteInvalidKey]
]);
// Map of DataErrorCode to HttpErrorCode
export const DataErrorCodeToHttpErrorCode = new Map([
    [DataErrorCodes.ImportEmptyFileError, 400],
    [DataErrorCodes.ImportUnsupportedEncoding, 500],
    [DataErrorCodes.ImportFieldSizeExceeded, 500],
    [DataErrorCodes.ImportPreprocessError, 400],
    [DataErrorCodes.ImportStreamIDNotFound, 400],
    [DataErrorCodes.ImportInvalidConfiguration, 400],
    [DataErrorCodes.SftpDecryptionKeyInvalid, 400],
    [DataErrorCodes.SftpDecryptionFailed, 500],
    [DataErrorCodes.SftpDecryptionMaxFilesizeError, 400],
    [DataErrorCodes.SftpFileNotFoundError, 400],
    [DataErrorCodes.SftpServerError, 500],
    [DataErrorCodes.SftpAuthenticationError, 401],
    [DataErrorCodes.ImportExcelWorksheetNotFound, 400],
    [DataErrorCodes.ImportExcelInvalidSpec, 400],
    [DataErrorCodes.ImportExcelUnsupportedFormat, 400],
    [DataErrorCodes.ImportExcelInvalidFile, 400],
    [DataErrorCodes.ImportExcelNotAZipFile, 400],
    [DataErrorCodes.FwfInvalidEncodingType, 400],
    [DataErrorCodes.OneDriveTokenError, 400],
    [DataErrorCodes.OneDriveFileNotFoundError, 400],
    [DataErrorCodes.OneDriveFileSizeExceededError, 400],
    [DataErrorCodes.OneDriveApiError, 400],
    [DataErrorCodes.ImportOdbcAuthenticationFailed, 401],
    [DataErrorCodes.ImportOdbcDatabaseDoesNotExist, 400],
    [DataErrorCodes.ImportOdbcConnectionTimeout, 408],
    [DataErrorCodes.ImportOdbcConnectionFailed, 400],
    [DataErrorCodes.ImportOdbcHostNotFound, 400],
    [DataErrorCodes.ImportOdbcTableNotFound, 400],
    [DataErrorCodes.ImportOdbcEmptyData, 400],
    [DataErrorCodes.ImportMsSqlQueryTimeout, 400],
    [DataErrorCodes.SnowflakeClientError, 400],
    [DataErrorCodes.SnowflakeServerError, 500],
    [DataErrorCodes.MySqlClientError, 400],
    [DataErrorCodes.MySqlServerError, 500],
    [DataErrorCodes.ImportSalesForceBulkApiDisabled, 400],
    [DataErrorCodes.ImportSalesForceInvalidField, 400],
    [DataErrorCodes.ImportSalesForceInvalidFilter, 400],
    [DataErrorCodes.ImportSalesForceApiError, 400],
    [DataErrorCodes.RestInvalidConfig, 400],
    [DataErrorCodes.RestInvalidData, 400],
    [DataErrorCodes.RestClientError, 400],
    [DataErrorCodes.TqpApiKeyInvalid, 401],
    [DataErrorCodes.TqpHostNotFound, 400],
    [DataErrorCodes.TqpCanceledByUser, 499],
    [DataErrorCodes.TqpGenericError, 400],
    [DataErrorCodes.TqpClientError, 400],
    [DataErrorCodes.IcmBadRequest, 400],
    [DataErrorCodes.IcmClientError, 400],
    [DataErrorCodes.IcmServerError, 500],
    [DataErrorCodes.WorkdayInvalidUsernameOrPassword, 400],
    [DataErrorCodes.WorkdayRaaSInvalidReportURL, 400],
    [DataErrorCodes.WorkdayInvalidDomainError, 400],
    [DataErrorCodes.WorkdayConnectionFailed, 400],
    [DataErrorCodes.WorkdayApiError, 400],
    [DataErrorCodes.HubspotApiError, 400],
    [DataErrorCodes.HubspotAuthInvalid, 401],
    [DataErrorCodes.GoogleApiClientError, 400],
    [DataErrorCodes.ImportDynamicsApiError, 400],
    [DataErrorCodes.ImportDynamicsInvalidUrl, 400],
    [DataErrorCodes.AgentSyncApiCallError, 400],
    [DataErrorCodes.AgentSyncInvalidKeySecret, 401],
    [DataErrorCodes.GongApiError, 400],
    [DataErrorCodes.NetSuiteInvalidAccountID, 400],
    [DataErrorCodes.NetSuiteInvalidKey, 400]
]);
//# sourceMappingURL=dataErrorCodes.js.map